<template lang="pug">
  v-row
    v-col(cols=12 lg=6)
      v-row
        v-col(cols=12 md=8).pb-3.pt-0
          card-last-win-number(
            :win-number-array="winNumberArray"
            :power-play="powerPlay"
          )
        v-col(cols=12 md=4).pt-0
          v-row
            v-col(cols=12).pt-0
              card-power-ball(
                :src="lastRoundSrc"
                :text="$t('view-result-last-round')"
                @click="$emit('changeMode',MODE_ORDER_RESULT)"
              )
            v-col(cols=12).py-0
              card-power-ball( 
                :src="listRoundSrc"
                :text="$t('my-order-item')"
                @click="$emit('changeMode',MODE_LAST_RESULT)"
              )
        v-col(cols=12).pt-0
          card-reward(
            :items="rewards"
          ) 
        v-col(cols=12)
          card-countdown-win-number(
            :closedAt="closedAt"
            :lockedAt="lockedAt"
            :openedAt="openedAt"
            @setOpenStatus="openStatus = $event"
          )
    v-col(cols=12 lg=6).pt-0
      stake-frame(
        v-if="openStatus"
        :uuid="uuid" 
        :price-stake="priceStake"
        :price-stake-power-play="priceStakePowerPlay"
        @success="load"
      )
      v-row(align="center" justify="center" style="height:100%;" v-else)
        v-card(
          color="var(--card-open-status)"
        ).pa-3.px-7
          h2.white--text {{ $t('power-ball.not-open-stake') }}
</template>
<script>
import CardLastWinNumber from '../components/CardLastWinNumber.vue'
import CardPowerBall from '../components/CardBasePowerBall.vue'
import CardReward from '../components/CardReward'
import CardCountdownWinNumber from '../components/CardCountdownWinNumber'
import StakeFrame from '../components/StakeFrame' 
  
const MODE_LAST_RESULT = 1
const MODE_ORDER_RESULT = 2

export default {
  components: {
    CardReward,
    CardLastWinNumber,
    CardPowerBall,
    CardCountdownWinNumber,
    StakeFrame
  },
  props: {
    uuid:{
      type: String,
      default: null
    },
    priceStake:{
      type: String,
      default: null
    },
    priceStakePowerPlay: {
      type: String,
      default: null
    },
    closedAt:{
      type: String,
      default: null
    },
    lockedAt:{
      type: String,
      default: null
    },
    openedAt: {
      type: String,
      default: null
    },
    rewards: {
      type: Array,
      default: () => []
    },
    winNumberArray: {
      type: Array,
      default: () => []
    },
    powerPlay: {
      type: Number,
      default: null
    },
    load: {
      type: Function,
      default: () => {}
    },
  },
  data: () => ({
    openStatus: false
  }),
  computed: {
    MODE_LAST_RESULT: () => MODE_LAST_RESULT,
    MODE_ORDER_RESULT: () => MODE_ORDER_RESULT,
    lastRoundSrc: () => require('@/assets/powerball/icon-clock-white.svg'),
    listRoundSrc: () => require('@/assets/powerball/icon_list.svg'),
  }
  
}
</script>